import { useEffect, useState } from 'react';

export interface Tip {
  title: string;
  body: string;
}

export const DID_YOU_KNOW: Tip[] = [
  {
    title: 'Project Stability Index',
    body: 'MFlow computes a PSI score from 0 to 100 for every project. Anything below 60 is a watch signal — below 40 means the project needs immediate attention.',
  },
  {
    title: 'Ask AI knows your data',
    body: 'The AI has full context of your Jira metrics — cycle time, blockers, contributor load. Ask it "what is slowing us down?" and get a data-backed answer.',
  },
  {
    title: 'Cycle time & lead time',
    body: 'MFlow tracks how long issues spend in each workflow state automatically. No tagging or custom fields needed — it reads directly from Jira transitions.',
  },
  {
    title: 'Risk flags',
    body: 'Each project is scanned for risk patterns: scope creep, stale issues, unbalanced workloads, and more. Risk flags surface the problems before they become blockers.',
  },
  {
    title: 'Contributor-level insights',
    body: 'Drill down from the studio overview all the way to an individual contributor to understand throughput, review load, and delivery consistency.',
  },
  {
    title: 'Incremental sync',
    body: 'After the first sync, MFlow only fetches what changed. Your dashboard updates stay fresh without repeated full scans.',
  },
];

export function useRotatingTip(active: boolean, intervalMs = 6000) {
  const [tipIndex, setTipIndex] = useState(0);
  const [tipVisible, setTipVisible] = useState(true);

  useEffect(() => {
    if (!active) return;
    const interval = setInterval(() => {
      setTipVisible(false);
      setTimeout(() => {
        setTipIndex((i) => (i + 1) % DID_YOU_KNOW.length);
        setTipVisible(true);
      }, 400);
    }, intervalMs);
    return () => clearInterval(interval);
  }, [active, intervalMs]);

  return { tip: DID_YOU_KNOW[tipIndex], tipIndex, tipVisible };
}
